export default __webpack_public_path__ + "static/investment-image-5-226c7f754f83e3d95e5a893294717b3a.jpg";